export default "/images/increase.svg"